import { Toolbar as MUIToolbar, ToolbarProps } from '@mui/material';

export { type ToolbarProps } from '@mui/material';

export function Toolbar(props: ToolbarProps) {
  return <MUIToolbar {...props} />;
}
